import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PautaVisualizarLayer from "../components/PautaVisualizarLayer";
import { useTranslation } from "../i18n/I18nContext";

const PautaVisualizarPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("nota.view.breadcrumb")} />
      <PautaVisualizarLayer />
    </MasterLayout>
  );
};

export default PautaVisualizarPage;
